import React, { useState } from 'react';
import AccordionItem from './accordion-item';

const Accordion = ({ data, modifier }) => {
    const [activeAccordion, setActiveAccordion] = useState('');

    const handleAccordionTrigger = (accordion) => {
        setActiveAccordion(accordion);
    };

    return (
        <div className={modifier}>
            {data.map((item, index) => (
                <AccordionItem
                    activeAccordion={activeAccordion}
                    content={item.content}
                    handleAccordionTrigger={handleAccordionTrigger}
                    index={index}
                    key={`${index}-accordion`}
                    title={item.title}
                />
            ))}
        </div>
    );
};

export default Accordion;
